module.exports = __webpack_public_path__ + "static/media/c6bannerModul1_small.39d49b34.jpg";